import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

import {ChatbotThreadsLearnMoreModal as ChatbotThreadsLearnMoreModalPage} from './pages/chatbot-threads-learn-more-modal';

export function ChatbotThreadsLearnMoreModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.CHATBOT_THREADS_LEARN_MORE_MODAL);

    const pages = [
        {
            id: 'chatbot-threads-learn-more-modal',
            body: <ChatbotThreadsLearnMoreModalPage />,
            art: {
                background: colors.blueXlt,
                image: () => (
                    <Illustration src='chatbot-onboarding/chatbot-threads-learn-more-modal' />
                ),
            },
        },
    ];

    return (
        isOpen && (
            <OnboardingModal
                trapFocus={false}
                lastButtonText='Done'
                pages={pages}
                onClose={onClose}
                onFinish={onClose}
                canClickOutsideToClose={false}
            />
        )
    );
}
